export function toCamelCase(text: string) {
  const [first, ...rest] = text
  return first ? first.toLocaleLowerCase() + rest.join('') : text
}
